(function(){document.querySelectorAll('.kpd[data-kpd-root]').forEach(function(root){if(root.__kpd)return;root.__kpd=1;

var dataEl = root.querySelector('[data-kpd-data]');
var DATA; try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
var flavs = DATA.flavours || [];
if (!flavs.length) return;
var sf = (DATA.sizeFilter || '').trim().toLowerCase();
if (sf) {
var ff = [];
flavs.forEach(function (f) {
var vs = (f.variants || []).filter(function (v) { return (v.title || '').toLowerCase().indexOf(sf) !== -1; });
if (vs.length) { f.variants = vs; ff.push(f); }
});
if (ff.length) flavs = ff;
}
var track = root.querySelector('[data-kpd-track]');
var prevBtn = root.querySelector('[data-kpd-prev]');
var nextBtn = root.querySelector('[data-kpd-next]');
var dotsC = root.querySelector('[data-kpd-dots]');
var flavWrap = root.querySelector('[data-kpd-flavs]');
var sizesWrap = root.querySelector('[data-kpd-sizes-wrap]');
var sizesC = root.querySelector('[data-kpd-sizes]');
var subBox = root.querySelector('[data-kpd-subscribe]');
var subToggle = root.querySelector('[data-kpd-sub-toggle]');
var benefits = root.querySelector('[data-kpd-benefits]');
var freqWrap = root.querySelector('[data-kpd-frequency]');
var freqSel = root.querySelector('[data-kpd-frequency-select]');
var oneTime = root.querySelector('[data-kpd-onetime]');
var priceCur = root.querySelector('[data-kpd-price-current]');
var priceOrig = root.querySelector('[data-kpd-price-original]');
var varInput = root.querySelector('[data-kpd-variant-id]');
var planInput = root.querySelector('[data-kpd-selling-plan]');
var cta = root.querySelector('[data-kpd-cta]');
var qtyInput = root.querySelector('[data-kpd-qty-input]');
var qtyMinus = root.querySelector('[data-kpd-qty-minus]');
var qtyPlus = root.querySelector('[data-kpd-qty-plus]');
var stickyEl = root.querySelector('[data-kpd-sticky]');
var stickySub = root.querySelector('[data-kpd-sticky-sub]');
if (stickyEl) document.body.appendChild(stickyEl);
var ingBody = root.querySelector('[data-kpd-ing-body]');
var nutBody = root.querySelector('[data-kpd-nut-body]');
var descBody = root.querySelector('[data-kpd-desc-body]');
var accIng = root.querySelector('[data-kpd-acc-ing]');
var accNut = root.querySelector('[data-kpd-acc-nut]');
var accDesc = root.querySelector('[data-kpd-acc-desc]');
var accCont = root.querySelector('[data-kpd-acc]');
function accHas(h){ return !!(h && h.replace(/<[^>]*>/g,'').replace(/&nbsp;/g,' ').trim()); }
var headingEl = root.querySelector('[data-kpd-heading]');
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var state = { fi: 0, vi: 0, idx: 0, qty: 1 };
function money(cents) { return '£' + (cents / 100).toFixed(2); }
/* ---- carousel ---- */
function buildSlides(f) {
track.innerHTML = '';
var cv = (f.variants || [])[state.vi];
var imgs = (f.slides || []).slice();
if (cv && cv.image) { imgs = [cv.image].concat(imgs.filter(function (s) { return s !== cv.image; })); }
(imgs.length ? imgs : ['']).forEach(function (src, k) {
var d = document.createElement('div'); d.className = 'kpd__slide';
if (src) { var im = document.createElement('img'); im.src = src; im.loading = k === 0 ? 'eager' : 'lazy'; im.alt = f.name; d.appendChild(im); }
track.appendChild(d);
});
state.idx = 0; goTo(0);
var n = track.children.length;
if (prevBtn) prevBtn.hidden = n <= 1;
if (nextBtn) nextBtn.hidden = n <= 1;
if (dotsC) {
dotsC.innerHTML = '';
if (n > 1) for (var j = 0; j < n; j++) { var b = document.createElement('button'); b.type = 'button'; b.className = 'kpd__dot' + (j === 0 ? ' is-active' : ''); (function (jj) { b.addEventListener('click', function () { goTo(jj); }); })(j); dotsC.appendChild(b); }
}
}
function goTo(i) {
var n = track.children.length; if (!n) return;
state.idx = (i % n + n) % n;
track.style.transform = 'translateX(-' + (state.idx * 100) + '%)';
if (dotsC) Array.prototype.forEach.call(dotsC.children, function (d, di) { d.classList.toggle('is-active', di === state.idx); });
}
if (nextBtn) nextBtn.addEventListener('click', function () { goTo(state.idx + 1); });
if (prevBtn) prevBtn.addEventListener('click', function () { goTo(state.idx - 1); });
/* ---- colour helpers ---- */
function textOn(hex){var c=(hex||'').replace('#','');if(c.length===3){c=c.replace(/(.)/g,'$1$1');}var r=parseInt(c.substr(0,2),16),g=parseInt(c.substr(2,2),16),bl=parseInt(c.substr(4,2),16);if(isNaN(r))return '#121212';return (0.299*r+0.587*g+0.114*bl)/255>0.6?'#121212':'#ffffff';}
function tintBg(hex,amt){var c=(hex||'').replace('#','');if(c.length===3){c=c.replace(/(.)/g,'$1$1');}var r=parseInt(c.substr(0,2),16),g=parseInt(c.substr(2,2),16),bl=parseInt(c.substr(4,2),16);if(isNaN(r)){r=206;g=224;bl=201;}function mix(x){return Math.round(x+(255-x)*amt);}return 'rgb('+mix(r)+','+mix(g)+','+mix(bl)+')';}
/* ---- animated background sweep (left-to-right) ---- */
var bgEl = root.closest('.shopify-section') || root;
var sweep = document.createElement('div'); sweep.className = 'kpd__bg-sweep'; sweep.setAttribute('aria-hidden','true');
var sweepInner = document.createElement('i'); sweep.appendChild(sweepInner);
var bgReady = false, sweepT = null;
bgEl.style.position = 'relative';
root.style.position = 'relative'; root.style.zIndex = '1'; root.style.backgroundColor = 'transparent';
if (!reduce) bgEl.appendChild(sweep);
function commitBg(t){ bgEl.style.backgroundColor = t; sweepInner.style.transition = 'none'; sweep.classList.remove('is-sweeping'); }
function setBg(col){
var t = tintBg(col, 0.86);
if (!bgReady || reduce) { bgEl.style.backgroundColor = t; bgReady = true; return; }
if (sweepT) clearTimeout(sweepT);
var clear = t.replace('rgb(','rgba(').replace(')',',0)');
sweepInner.style.background = 'linear-gradient(90deg,' + t + ' 0%,' + t + ' 68%,' + clear + ' 100%)';
sweepInner.style.transition = 'none';
sweep.classList.remove('is-sweeping');
void sweepInner.offsetWidth;
sweepInner.style.transition = 'transform 1.1s cubic-bezier(.33,0,.2,1)';
sweep.classList.add('is-sweeping');
sweepT = setTimeout(function(){ commitBg(t); }, 1160);
}
/* ---- flavour dropdown ---- */
var trigger=document.createElement('button');trigger.type='button';trigger.className='kpd__select';trigger.setAttribute('aria-haspopup','listbox');trigger.setAttribute('aria-expanded','false');
var selLabel=document.createElement('span');selLabel.className='kpd__select-label';
var chev=document.createElement('span');chev.className='kpd__select-chevron';chev.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>';
trigger.appendChild(selLabel);trigger.appendChild(chev);
var panel=document.createElement('div');panel.className='kpd__select-panel';panel.setAttribute('role','listbox');panel.hidden=true;
var opts=[];
flavs.forEach(function(f,i){
var o=document.createElement('button');o.type='button';o.className='kpd__option';o.setAttribute('role','option');o.setAttribute('data-fi',i);
var dot=document.createElement('span');dot.className='kpd__option-dot';dot.style.background=f.color||'#cee0c9';
var nm=document.createElement('span');nm.className='kpd__option-name';nm.textContent=f.name;
o.appendChild(dot);o.appendChild(nm);
o.addEventListener('click',function(){selectFlavour(i);closePanel();trigger.focus();});
panel.appendChild(o);opts.push(o);
});
flavWrap.appendChild(trigger);flavWrap.appendChild(panel);
function openPanel(){panel.hidden=false;trigger.setAttribute('aria-expanded','true');flavWrap.classList.add('is-open');}
function closePanel(){panel.hidden=true;trigger.setAttribute('aria-expanded','false');flavWrap.classList.remove('is-open');}
trigger.addEventListener('click',function(e){e.stopPropagation();if(panel.hidden){openPanel();}else{closePanel();}});
trigger.addEventListener('keydown',function(e){if(e.key==='ArrowDown'){e.preventDefault();openPanel();var a=opts[state.fi]||opts[0];if(a)a.focus();}});
panel.addEventListener('keydown',function(e){var idx=opts.indexOf(document.activeElement);if(e.key==='Escape'){e.preventDefault();closePanel();trigger.focus();}else if(e.key==='ArrowDown'){e.preventDefault();(opts[idx+1]||opts[0]).focus();}else if(e.key==='ArrowUp'){e.preventDefault();(opts[idx-1]||opts[opts.length-1]).focus();}});
document.addEventListener('click',function(e){if(!flavWrap.contains(e.target))closePanel();});
/* ---- size buttons ---- */
function buildSizes(f) {
if (!DATA.showSize || !sizesWrap) return;
var vs = f.variants || [];
if (vs.length < 2) { sizesWrap.hidden = true; return; }
sizesWrap.hidden = false;
sizesC.innerHTML = '';
vs.forEach(function (v, i) {
var b = document.createElement('button'); b.type = 'button'; b.className = 'kpd__size'; b.textContent = v.title;
if (!v.available) b.disabled = true;
b.addEventListener('click', function () { if (!v.available) return; selectVariant(i); });
sizesC.appendChild(b);
});
}
function markActiveSize() {
if (!sizesC) return;
Array.prototype.forEach.call(sizesC.children, function (b, i) { b.classList.toggle('is-active', i === state.vi); });
}
/* ---- subscribe / plans ---- */
function buildPlans(f) {
var plans = f.plans || [];
if (!plans.length) { subBox.hidden = true; return; }
subBox.hidden = false;
freqSel.innerHTML = '';
plans.forEach(function (p) { var o = document.createElement('option'); o.value = p.id; o.textContent = p.name; freqSel.appendChild(o); });
}
function applySubState() {
var on = subToggle && subToggle.checked;
if (benefits) benefits.hidden = !on;
if (freqWrap) freqWrap.hidden = !on;
if (oneTime) oneTime.hidden = on;
}
if (subToggle) subToggle.addEventListener('change', function () { applySubState(); updateCart(); });
if (freqSel) freqSel.addEventListener('change', updateCart);
function setQty(n){ n = parseInt(n,10); if(isNaN(n)||n<1)n=1; state.qty=n; if(qtyInput)qtyInput.value=n; updatePrice(); }
if (qtyMinus) qtyMinus.addEventListener('click', function(){ setQty(state.qty-1); });
if (qtyPlus) qtyPlus.addEventListener('click', function(){ setQty(state.qty+1); });
if (qtyInput) qtyInput.addEventListener('change', function(){ setQty(qtyInput.value); });
/* ---- price + cart ---- */
function currentVariant() { return (flavs[state.fi].variants || [])[state.vi]; }
function updatePrice() {
var v = currentVariant(); if (!v) return;
var q = state.qty || 1;
var on = subToggle && subToggle.checked && (flavs[state.fi].plans || []).length;
if (on && DATA.discount > 0) {
var disc = Math.round(v.price * (1 - DATA.discount / 100));
priceCur.textContent = money(disc * q);
if (priceOrig) { priceOrig.textContent = money(v.price * q); priceOrig.hidden = false; }
} else {
priceCur.textContent = money(v.price * q);
if (priceOrig) priceOrig.hidden = true;
}
updateSticky();
}
function updateSticky() {
if (!stickySub) return;
var v = currentVariant(); if (!v) { stickySub.innerHTML = ''; return; }
var q = state.qty || 1;
var on = subToggle && subToggle.checked && (flavs[state.fi].plans || []).length;
var freq = (freqSel && freqSel.options[freqSel.selectedIndex]) ? freqSel.options[freqSel.selectedIndex].textContent : '';
if (on && DATA.discount > 0) {
var disc = Math.round(v.price * (1 - DATA.discount / 100));
stickySub.innerHTML = (freq ? freq + ' \u2014 ' : '') + money(disc * q) + ' <s>' + money(v.price * q) + '</s>';
} else if (on) {
stickySub.innerHTML = (freq ? freq + ' \u2014 ' : '') + money(v.price * q);
} else {
stickySub.innerHTML = 'One-time \u2014 ' + money(v.price * q);
}
}
function updateCart() {
var v = currentVariant(); if (!v) { cta.disabled = true; return; }
varInput.value = v.id;
var on = subToggle && subToggle.checked && (flavs[state.fi].plans || []).length;
if (on && freqSel.value) { planInput.value = freqSel.value; planInput.disabled = false; }
else { planInput.value = ''; planInput.disabled = true; }
cta.disabled = !v.available;
updatePrice();
}
function selectVariant(i) { state.vi = i; markActiveSize(); buildSlides(flavs[state.fi]); updateCart(); }
function selectFlavour(i) {
state.fi = i; state.vi = 0;
var f = flavs[i];
var col = f.color || '#cee0c9';
selLabel.textContent = f.name;
trigger.style.background = col; trigger.style.color = textOn(col);
opts.forEach(function (o, k) { o.classList.toggle('is-active', k === i); o.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
setBg(col);
if (DATA.headingFromFlavour && headingEl) headingEl.textContent = f.name;
if (ingBody) ingBody.innerHTML = f.ingredients || '';
if (nutBody) nutBody.innerHTML = f.nutrition || '';
if (descBody) descBody.innerHTML = f.description || '';
if (accIng) { accIng.hidden = !accHas(f.ingredients); if (accIng.hidden) accIng.open = false; }
if (accNut) { accNut.hidden = !accHas(f.nutrition); if (accNut.hidden) accNut.open = false; }
if (accDesc) { accDesc.hidden = !accHas(f.description); if (accDesc.hidden) accDesc.open = false; }
if (accCont) accCont.hidden = (!accIng || accIng.hidden) && (!accNut || accNut.hidden) && (!accDesc || accDesc.hidden);
buildSlides(f);
buildSizes(f);
buildPlans(f);
applySubState();
updateCart();
}
selectFlavour(0);
if (stickyEl && cta && 'IntersectionObserver' in window) { new IntersectionObserver(function(es){ es.forEach(function(e){ stickyEl.hidden = e.isIntersecting; }); }, { threshold: 0 }).observe(cta); }
});})();